/**
 * utils/misc
 *
 * Most of these are essentially replacements for Ramda,
 * used to keep size down in the final deliverable.
 */
/**
 * Returns the value at the given path of the object.
 * If it is not defined, return the default value.
 */
export const pathOr = (defaultValue, path, obj) => {
    let val = obj;
    let idx = 0;
    while (idx < path.length) {
        if (val == null) {
            return defaultValue;
        }
        val = val[path[idx]];
        idx += 1;
    }
    return val === null || val === undefined ? defaultValue : val;
};
/**
 * Return all the values of an object.
 */
export const values = (obj) => Object.keys(obj).map(key => obj[key]);
/**
 * Filter an object by testing it's values.
 */
export const pickBy = (test, obj) => Object.keys(obj)
    .filter(key => {
    return test(obj[key], key, obj);
})
    .reduce((acc, key) => (Object.assign(Object.assign({}, acc), { [key]: obj[key] })), {});
/**
 * Create a unique hash from a string.
 *
 * Note: This is not a secure implementation and
 * should not be used for hashing passwords, etc.
 */
export const hashString = (input) => {
    let hash = 0;
    if (input.length === 0) {
        return hash.toString();
    }
    for (let i = 0; i < input.length; i++) {
        const char = input.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash = hash & hash; // Convert to 32bit integer
    }
    return hash.toString();
};
/**
 * Remove any object properties with `undefined` values.
 */
export const removeUndefinedValues = (input) => Object.keys(input).reduce((carrier, key) => {
    const value = input[key];
    return typeof value === 'undefined'
        ? carrier
        : Object.assign(Object.assign({}, carrier), { [key]: value });
}, {});
/**
 * Typeguard boolean value - eliminate any falsy type from Array.filter
 *
 * Usage:
 * glasses.filter(truthy) => Glass[]
 */
export const isTruthy = (value) => !!value;
